import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as pdfjsLib from "pdfjs-dist/build/pdf";

export interface UpperbeltPdfViewerData {
  name: string;
  pdfBlob: Blob;
}

@Component({
  selector: "app-upperbelt-pdf-viewer",
  templateUrl: "./upperbelt-pdf-viewer.component.html",
  styleUrls: ["./upperbelt-pdf-viewer.component.scss"],
})
export class UpperbeltPdfViewerComponent implements AfterViewInit, OnDestroy {
  @ViewChild("pagesContainer") pagesContainer: ElementRef<HTMLDivElement>;

  loading = true;
  error: string | null = null;

  private renderTask: pdfjsLib.PDFDocumentProxy | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: UpperbeltPdfViewerData) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = "assets/pdf.worker.min.js";
  }

  async ngAfterViewInit(): Promise<void> {
    try {
      const buffer = await this.data.pdfBlob.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;
      this.renderTask = pdf;

      const container = this.pagesContainer.nativeElement;
      const containerWidth = Math.min(window.innerWidth * 0.92, 1400);

      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
        const page = await pdf.getPage(pageNumber);
        const unscaledViewport = page.getViewport({ scale: 1 });
        const scale = containerWidth / unscaledViewport.width;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        canvas.className = "pdf-page";
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const context = canvas.getContext("2d");
        await page.render({ canvasContext: context, viewport }).promise;
        container.appendChild(canvas);
      }

      this.loading = false;
    } catch {
      this.loading = false;
      this.error = "Unable to display PDF";
    }
  }

  ngOnDestroy(): void {
    this.renderTask?.destroy();
  }
}
